import { render } from "./BasicInfo.vue?vue&type=template&id=ec332b68&scoped=true&ts=true"
import script from "./BasicInfo.vue?vue&type=script&lang=ts"
export * from "./BasicInfo.vue?vue&type=script&lang=ts"

import "./BasicInfo.vue?vue&type=style&index=0&id=ec332b68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec332b68"]])

export default __exports__